import { gql, TypedDocumentNode } from '@apollo/client';

import { QueryGetCandidateSuggestionsModalJobsArgs, SuggestionModalJobsDto } from '@pflegia/data-access';

import { JOB_BOARD_POSITION_FRAGMENT } from '../fragments/job-position';

export const GET_CANDIDATE_SUGGESTIONS_MODAL_JOBS: TypedDocumentNode<
  { data: SuggestionModalJobsDto },
  QueryGetCandidateSuggestionsModalJobsArgs
> = gql`
  query getCandidateSuggestionsModalJobs($filters: JobBoardFiltersInput!, $suggestionsModalInput: SuggestionsModalInput!) {
    data: getCandidateSuggestionsModalJobs(filters: $filters, suggestionsModalInput: $suggestionsModalInput) {
      jobPositions {
        ...JobBoardPositionFragment
      }
      canDisplayModal
    }
  }
  ${JOB_BOARD_POSITION_FRAGMENT}
`;
